<div class="public-background bg-gradient-to-br from-white to-primary-500">
  <div class="relative w-full max-w-2xl mx-auto mb-6">
    <a routerLink="/">
      <img src="/assets/qb-logo-dark.svg" alt="QualityBidders" />
    </a>
  </div>
  <div class="relative max-w-2xl p-5 mx-auto bg-white rounded-md shadow-lg pb-7 dark:bg-gray-600 dark:text-gray-50">
    <h1 class="mb-8 text-2xl">Your account account has been created! Please confirm your email.</h1>
    <p class="mb-8">An confirmation email has been sent to your email address. Please click the link in that email to complete your account setup.</p>
    <p class="mb-2 font-medium">Haven't received your email from QualityBidders&#64;colbitech.com?</p>
    <p class="mb-6">Check your junk, spam, or promotions folder. If you still haven't received the email, click the button below to resend the confirmation email.</p>
    <div class="text-center">
      <button mat-raised-button color="primary" type="button" (click)="resend()">Resend Confirmation Email</button>
    </div>
  </div>
</div>
